import { DataNode } from "../data/types";

export const nodeValue = (dn: DataNode) => ({
  value: dn.selectValue ?? dn.value,
  title: dn.title,
});
